import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { SignInComponent } from './layout/components/sign-in/sign-in.component';
import { SignOutComponent } from './layout/components/sign-out/sign-out.component';
import { AdvancedSearchJobsComponent } from './job/components/job-dashboard/advanced-search-jobs/advanced-search-jobs.component';
import { SignInCheckComponent } from './layout/components/sign-in-check/sign-in-check.component';
import { CreditCardGuard } from './core/guards/credit-card.guard';
import { AccountInReviewComponent } from './layout/components/account-in-review/account-in-review.component';
import { AssetGuard } from './core/guards/asset.guard';
import { AssetDashboardComponent } from './asset/components/asset-dashboard/asset-dashboard.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/sign-in-check' },
  {
    path: 'sign-in',
    component: SignInComponent,
  },
  {
    path: 'sign-in-check',
    component: SignInCheckComponent,
  },
  {
    path: 'sign-out',
    component: SignOutComponent,
  },
  {
    path: 'job',
    loadChildren: () => import('./job/job.module').then((m) => m.JobModule),
    canActivate: [AuthGuard, CreditCardGuard],
  },
  {
    path: 'property',
    loadChildren: () =>
      import('./property/property.module').then((m) => m.PropertyModule),
    canActivate: [AuthGuard, CreditCardGuard],
  },
  {
    path: 'insight',
    loadChildren: () =>
      import('./insight/insight.module').then((m) => m.InsightModule),
    canActivate: [AuthGuard, CreditCardGuard],
  },
  {
    path: 'tradee',
    loadChildren: () =>
      import('./tradee/tradee.module').then((m) => m.TradeeModule),
    canActivate: [AuthGuard, CreditCardGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'advanced-search',
    component: AdvancedSearchJobsComponent,
  },
  {
    path: 'communications',
    loadChildren: () =>
      import('./communications/communications.module').then(
        (m) => m.CommunicationsModule
      ),
    canActivate: [AuthGuard, CreditCardGuard],
  },
  {
    path: 'inspection-manager',
    loadChildren: () =>
      import('./inspection-manager/inspection-manager.module').then(
        (m) => m.InspectionManagerModule
      ),
    canActivate: [AuthGuard, CreditCardGuard],
  },
  {
    path: 'static-pages',
    loadChildren: () =>
      import('./static-pages/static-pages.module').then(
        (m) => m.StaticPagesModule
      )
  },
  {
    path: 'account-in-review',
    component: AccountInReviewComponent,
  },
  {
    path: 'asset',
    loadChildren: () =>
      import('./asset/asset.module').then((m) => m.AssetModule),
    canActivate: [AuthGuard,AssetGuard],
  },
  {
    path: 'view-assets',
    component: AssetDashboardComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
